<script setup>
import { useAuthStore } from '@/stores/auth'

const authStore = useAuthStore()
</script>

<template>
  <div>

    <v-card class="mb-6">
      <v-card-text class="text-center pa-8">
        <v-icon size="64" color="primary" class="mb-4">mdi-home-analytics</v-icon>
        <h2 class="text-h4 mb-4">Bem-vindo ao Painel de Controle</h2>
        <h3 class="text-h5 mb-6">TMKT - Preço do Gás</h3>
        
        <p class="text-body-1 mb-2">
          Olá <strong>{{ authStore.user?.nome }}</strong>, bem-vindo ao sistema de gestão.
        </p>
        <p class="text-body-1 mb-6">
          Utilize o menu lateral para navegar entre as funcionalidades disponíveis.
        </p>
        
        <v-divider class="my-6"></v-divider>
        
        <p class="text-subtitle-1 text-medium-emphasis">
          Seu perfil: <strong>{{ authStore.user?.perfil.descricao }}</strong>
        </p>
      </v-card-text>
    </v-card>
  </div>
</template>
